import React, {useContext, useEffect, useState} from "react";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import CacheAndBank from "./CacheAndBank";
import SellType from "./SellType";
import ProvinceAndCity from "./ProvinceAndCity";
import FactorTypeSelect from "./FactorTypeSelect";
import PaymentTypeSelect from "./PaymentTypeSelect";
import TitlePriceTaxDiscount from "./TitlePriceTaxDiscount";
import {toast} from "react-toastify";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import numericFunction from "../../../utils/NumericFunction";
import SelectCustomer from "./SelectCustomer";
import {
  calculateTotalSum,
  isPaymentAndFactorSumEqual,
} from "../SellFactorFunctionsSadan";
import sellFactorData from "../sellFactorData";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";
import TextareaCustom from "../../Factor/TextareaCustom";
import OrderId from "./OrderId";
import Swal from "sweetalert2";
import OrganizeCode from "./OrganizeCode";
import SendTypeSellFactor from "./SendTypeSellFactor";
import SelectCourier from "./SelectCourier";
import SelectSendStatus from "./SelectSendStatus";
import DistributorContractor from "./DistributorContractor";
import SelectDistributorContractor from "./SelectDistributorContractor";
import SelectTime from "./SelectTime";
import SelectAddress from "./SelectAddress";

const SellFactorKOL = ({
                         sendData,
                         setSendData,
                         initialData,
                         componentData,
                         setComponentData,
                       }) => {
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(true);
  
  // Create today's date using DateObject for consistent formatting
  const todayDateObject = new DateObject({
    calendar: persian,
    locale: persian_fa
  });
  const todayDate = todayDateObject.format("YYYY/MM/DD");

  // data use in submit Form
  const setprint = useContext(SetPrintDataContext);
  const navigateTo = useNavigate();

  useEffect(() => {
    // اگر سری اول خالی بود یعنی بک اند چیزی نفرستاده و من باید تاریخ امروز رو بزارم جای مقدار دیت
    if (sendData.date === "") {
      setSendData({date: todayDate});
    }
  }, [sendData]);

  const submitHandler = (wannaPrint = 0) => {
    const temp = {...sendData};

    if (temp.tableData.length === 0) {
      toast.error("فاکتور جز را پر کنید");
      return;
    }
    if (temp.paymentType === "cacheAndBank") {
      if (sendData.priceData.length === 0) {
        toast.error("فاکتور کل بدون مبلغ می باشد.");
        return;
      }
    }

    // sum of product must be equal to sum of payments
    if (
      temp.paymentType === "cacheAndBank" &&
      !isPaymentAndFactorSumEqual(sendData)
    ) {
      toast.error("مبلغ پرداختی با مبلغ فاکتور برابر نیست!.");
      return;
    }

    if (
      temp.paymentType === "cacheAndBank" &&
      calculateTotalSum(sendData).sum < 0
    ) {
      toast.error("مبلغ کل نمیتواند منفی باشد.!.");
      return;
    }

    if(sendData.sendStatus===""){
      toast.error("وضعیت ارسال را مشخص کنید.");
      return;
    }

    temp.date = numericFunction.p2e(temp.date);
    setIsSubmitButtonActive(false);
    toast("در حال ثبت فاکتور...");
    const result = _axios
      .post(prefixUrl() + "/groceryStoreSellFactor/", {
        request: "factorConfirm",
        factorData: temp,
      })
      .then((res) => {
        setIsSubmitButtonActive(true);
        const data = res.data;
        if (data.status) {
          toast.success(data.message);
          if (wannaPrint === 1) {
            // اینجا باید انتیتی نام اضافه کنم تا
            data.invoiceData.entityName = "FAKKOLSELL"
            data.invoiceData.type = "HAVALEANBAR";
            setprint(data.invoiceData);
            navigateTo("/factorprint");
          } else {
            setSendData({
              ...sellFactorData.initialSendData,
              serviceTitle: sendData.serviceTitle,
              servicePrice: sendData.servicePrice,
              city: sendData.city,
              province: sendData.province,
            });

            if (temp.mode === 'edit') {
              navigateTo(-1)
            }
          }
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsSubmitButtonActive(true);
      });
  
    toast.promise(result, {
      pending: "در حال ثبت فاکتور",
    });
  };

  const showStorePrintCheckBoxHandler = (e) => {
    const checkedValue = e.target.checked
    if (checkedValue === true) {
      Swal.fire({
        title: "پرینت انبار فعال باشد ",
        text: `با فعالسازی این بخش پس از ثبت فرم، درخواست چاپ رسید به انبار ارسال میشه! و شما نمیتوانید این فرم رو ویرایش کنید!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'فعال',
        cancelButtonText: 'لغو'
      }).then((result) => {
        if (result.isConfirmed) {
          setSendData({storePrintFlag: checkedValue})
        }
      })
    } else {
      setSendData({storePrintFlag: checkedValue})
    }
  }

  console.log(sendData.sendType)
  return (
    <>
      <div className="total">
        <h5 className="factor-title">فاکتور فروش کل</h5>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            submitHandler(0);
          }}
          autoComplete={"off"}
        >
          <div className={'divgroup'}>
            <label htmlFor="">تاریخ</label>
            <div className="form-control">
              <DatePicker
                onChange={(date) => {
                  if (date) {
                    // Use explicit format with 2-digit month and day for consistent sorting
                    setSendData({date: date.format("YYYY/MM/DD")});
                  } else {
                    setSendData({date: ""});
                  }
                }}
                calendar={persian}
                className="form-control"
                placeholder="تاریخ"
                locale={persian_fa}
                value={sendData.date || todayDate}
                calendarPosition="bottom-right"
                hideOnScroll
              />
            </div> 
          </div>
          {sendData.showOrderId && <OrderId
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}
          <PaymentTypeSelect
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />
          {sendData.paymentType === "cacheAndBank" ? (
            <CacheAndBank
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
          ) : sendData.paymentType === "debt" ? (
            <>
              <SelectCustomer
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
              {sendData.customerType==="سازمانی" && <OrganizeCode
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />}
            </>
          ) : (
            <></>
          )}

          {<SendTypeSellFactor
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}
          {sendData.sendType==="courier" && <SelectCourier
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}
          {sendData.sendType!=='inPlace' && <SelectSendStatus
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}
          {sendData.sendStatus ==="courier" && <SelectTime
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}
          <SelectAddress
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />

          {sendData.sendType==="distributorContractor" && <SelectDistributorContractor
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />}

          {/* اگر کلید ترو بود باید من نوع بستر فروش اینستاگرام تلگرام رو نشون بدم*/}
          {initialData.sellType && (
            <SellType
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
          )}
          
          <TitlePriceTaxDiscount
            sendData={sendData}
            setSendData={setSendData}
            initialData={initialData}
            componentData={componentData}
            setComponentData={setComponentData}
          />

          {<div className={'divgroup'}>
            <label htmlFor="sendData__description">توضیحات</label>
            <div className={"form-control active__outline"}>
              <TextareaCustom
                className={'form-control'}
                id={'sendData__description'}
                value={sendData.description}
                onChange={(e) => setSendData({description: e.target.value})}
                placeholder={"توضیحات "}
                name="hi"
              />
            </div>
          </div>}
          {
            initialData.showStorePrintCheckBox &&
            <div className={'d-flex '}>
              <input
                id={'showStorePrintCheckBox'}
                type={"checkbox"}
                onChange={showStorePrintCheckBoxHandler}
                checked={sendData.storePrintFlag}
              />
              <label htmlFor="showStorePrintCheckBox"> پرینت در انبار</label>
            </div>
          }

          <input
            disabled={!isSubmitButtonActive}
            type="submit"
            className="btnCustom btnSubmit mt-5 py-5 w-100"
            value="ثبت فاکتور"
          />
        </form>
        <button
          disabled={!isSubmitButtonActive}
          className="print-btn btn-outline-primary"
          onClick={(event) => {
            event.preventDefault();
            submitHandler(1);
          }}
        >
          <i className="fas fa-print mr-2"></i>ثبت و پرینت
        </button>
      </div>
    </>
  );
};

export default SellFactorKOL;